import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  watcher_values = {}

  constructor() { }

  setWatchedSessionStorage(label, value)
  {
    if (this.watcher_values[label] === undefined)
    {
      this.watcher_values[label] = new Subject();
    }
    sessionStorage.setItem(label, value);
    this.watcher_values[label].next(value);
  }

  getWatchedSessionStorage(label)
  {
    let tmp = sessionStorage.getItem(label);
    return tmp === "undefined" ? undefined : tmp;
  }

  getWatcher(label)
  {
    if (this.watcher_values[label] === undefined)
    {
      this.watcher_values[label] = new Subject();
    }
    return this.watcher_values[label];
  }
  
}

